/* ============================================================
   ALF&mabi — JS personalizado
   Reordena la ficha de producto: coloca "Compartir" y
   "Añadir a favoritos" como iconos únicos (en su cuadro) a la
   derecha del botón "Añadir a la cesta". Los estilos van en
   custom.css. Se carga desde layout/theme.liquid con:
   <script src="{{ 'custom.js' | asset_url }}" defer></script>
   ============================================================ */
(function () {
  // Icono de compartir: reutiliza el del tema si existe
  function buildShareIcon(sb) {
    var i = sb.querySelector('.icon-share');
    return i
      ? i.outerHTML
      : '<svg viewBox="0 0 16 16" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.2">' +
        '<circle cx="12" cy="3.5" r="1.6"/><circle cx="4" cy="8" r="1.6"/><circle cx="12" cy="12.5" r="1.6"/>' +
        '<path d="M5.4 7.2 10.6 4.3M5.4 8.8l5.2 2.9"/></svg>';
  }

  // Añade un icono de corazón en la cabecera, enlazando a la página de
  // favoritos, entre el icono de cuenta y la lupa de buscar.
  var HEART_SVG =
    '<svg aria-hidden="true" fill="none" focusable="false" width="24" class="header__nav-icon icon" viewBox="0 0 24 24">' +
    '<path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09' +
    'C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35Z" ' +
    'stroke="currentColor" stroke-width="2" stroke-linejoin="round"/></svg>';

  function addHeaderHeart() {
    var searchLinks = document.querySelectorAll('.header__search-link');
    for (var i = 0; i < searchLinks.length; i++) {
      var searchLi = searchLinks[i];
      var ul = searchLi.parentElement;
      if (!ul || ul.querySelector('.header__favorites-link')) continue;
      var li = document.createElement('li');
      li.className = 'header__favorites-link';
      li.innerHTML =
        '<a href="/pages/favoritos" aria-label="Favoritos">' +
        '<span class="sr-only">Favoritos</span>' + HEART_SVG + '</a>';
      ul.insertBefore(li, searchLi); // a la izquierda de la lupa
    }
  }

  // Oculta la etiqueta del corazón dentro del Shadow DOM (todos los botones)
  function iconizeWishlist() {
    var btns = document.querySelectorAll('ooo-wl-product-page-button');
    for (var i = 0; i < btns.length; i++) {
      var wl = btns[i];
      if (wl.shadowRoot && !wl.shadowRoot.getElementById('alf-icononly')) {
        var s = document.createElement('style');
        s.id = 'alf-icononly';
        s.textContent =
          'button>span:not(.loader){display:none!important;}' +
          'button{gap:0!important;padding:0!important;min-height:0!important;height:auto!important;justify-content:center!important;}';
        wl.shadowRoot.appendChild(s);
      }
    }
  }

  function apply() {
    var list = document.querySelector('.product-info__block-list');

    // 1) Agrupa los tres bloques en una fila flex (una sola vez)
    if (list && !document.querySelector('.alf-cart-row')) {
      var items = [].slice.call(list.children);
      var cart  = items.filter(function (el) { return el.querySelector(':scope > product-form'); })[0];
      var share = items.filter(function (el) { return el.querySelector(':scope > share-button'); })[0];
      var fav   = items.filter(function (el) { return el.querySelector('[id*="wishlist_power_block_wishlist_product_page_button"]'); })[0];
      if (cart && share && fav) {
        document.querySelectorAll('.alf-cart-row').forEach(function (r) {
          if (!r.querySelector('product-form')) r.remove(); // limpia filas vacías tras un re-render
        });
        var row = document.createElement('div');
        row.className = 'alf-cart-row';
        cart.parentNode.insertBefore(row, cart);
        cart.classList.add('alf-cart-col');
        share.classList.add('alf-icon-box');
        fav.classList.add('alf-icon-box');
        row.appendChild(cart);
        row.appendChild(share);
        row.appendChild(fav);
      }
    }

    // 2) Compartir: un solo icono que abre las redes en un popup (independiente del paso 1)
    var sb = document.querySelector('share-button');
    var sdiv = sb && sb.querySelector('.share-buttons:not(.share-buttons--native)');
    if (sb && sdiv && !sb.querySelector('.alf-share-trigger')) {
      var lbl = sdiv.querySelector('span');
      if (lbl) lbl.style.display = 'none';               // oculta el texto "Compartir"
      var ul = sdiv.querySelector('ul.social-media');    // lista real de redes del tema
      var pop = document.createElement('div');
      pop.className = 'alf-share-pop';
      if (ul) pop.appendChild(ul);
      var trig = document.createElement('button');
      trig.type = 'button';
      trig.className = 'alf-share-trigger';
      trig.setAttribute('aria-label', 'Compartir');
      trig.innerHTML = buildShareIcon(sb);
      sdiv.appendChild(trig);
      sdiv.appendChild(pop);
      trig.addEventListener('click', function (e) {
        e.stopPropagation();
        sb.classList.toggle('alf-open');
      });
    }

    // 3) Favoritos: solo el corazón (independiente del paso 1; se aplica
    //    cuando el Shadow DOM de la app esté listo, aunque cargue tarde)
    iconizeWishlist();

    // 4) Icono de favoritos en la cabecera (en todas las páginas)
    addHeaderHeart();
  }

  // Enlaza listeners globales una sola vez
  if (!window.__alfBound) {
    window.__alfBound = true;
    // cierra el popup de compartir al hacer clic fuera
    document.addEventListener('click', function () {
      var open = document.querySelector('share-button.alf-open');
      if (open) open.classList.remove('alf-open');
    });
    // reaplica tras cambios de variante / re-render de la ficha
    new MutationObserver(function () { apply(); })
      .observe(document.documentElement, { childList: true, subtree: true });
  }

  // Ejecuta al cargar + reintentos por si la app del wishlist tarda en montar
  function boot() {
    apply();
    [200, 600, 1200, 2500, 4000].forEach(function (t) { setTimeout(apply, t); });
  }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  window.addEventListener('load', apply);
})();

/* ============================================================
   FOOTER ALF&mabi: acordeón solo en móvil
   - Escritorio (>= 700px): todas las secciones siempre abiertas, sin interacción.
   - Móvil (< 700px): arrancan cerradas y solo puede haber una abierta a la vez.
   El HTML llega con <details open>, así que sin JS todo el contenido sigue visible.
   ============================================================ */
(function () {
  var mq = window.matchMedia('(min-width: 700px)');
  var SEL = '.footer-acc';

  function all() {
    return document.querySelectorAll(SEL);
  }

  // Estado inicial / cambio de breakpoint
  function sync() {
    var items = all();
    for (var i = 0; i < items.length; i++) {
      if (mq.matches) {
        items[i].setAttribute('open', '');
      } else {
        items[i].removeAttribute('open');
      }
    }
  }

  // Clic en el título (delegado: funciona también al recargar la sección en el editor)
  document.addEventListener('click', function (e) {
    var summary = e.target.closest && e.target.closest('.footer-acc__summary');
    if (!summary) return;
    e.preventDefault();
    if (mq.matches) return; // escritorio: no se pliega

    var current = summary.parentElement;
    var opening = !current.hasAttribute('open');
    var items = all();
    for (var i = 0; i < items.length; i++) {
      if (items[i] !== current) items[i].removeAttribute('open');
    }
    if (opening) current.setAttribute('open', '');
    else current.removeAttribute('open');
  });

  sync();
  if (mq.addEventListener) mq.addEventListener('change', sync);
  else if (mq.addListener) mq.addListener(sync);
  document.addEventListener('DOMContentLoaded', sync);
  document.addEventListener('shopify:section:load', sync); // editor de temas
})();